export function autoupdateCurrentTime(
  store: {setCurrentTime: (currentTime: number) => void},
  intervalMs: number
) {
  return setInterval(() => {
    store.setCurrentTime(Date.now());
  }, intervalMs);
}
